/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RenameAgentForm,
  RenameAgentForm$Outbound,
  RenameAgentForm$outboundSchema,
} from "../components/renameagentform.js";

export type RenameAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RenameAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  renameAgentForm: RenameAgentForm;
};

/** @internal */
export type RenameAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RenameAgentSecurity$outboundSchema: z.ZodMiniType<
  RenameAgentSecurity$Outbound,
  RenameAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function renameAgentSecurityToJSON(
  renameAgentSecurity: RenameAgentSecurity,
): string {
  return JSON.stringify(
    RenameAgentSecurity$outboundSchema.parse(renameAgentSecurity),
  );
}

/** @internal */
export type RenameAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RenameAgentForm: RenameAgentForm$Outbound;
};

/** @internal */
export const RenameAgentRequest$outboundSchema: z.ZodMiniType<
  RenameAgentRequest$Outbound,
  RenameAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    renameAgentForm: RenameAgentForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      renameAgentForm: "RenameAgentForm",
    });
  }),
);

export function renameAgentRequestToJSON(
  renameAgentRequest: RenameAgentRequest,
): string {
  return JSON.stringify(
    RenameAgentRequest$outboundSchema.parse(renameAgentRequest),
  );
}
